import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { COOKIE_SID, TRACE_LOG_QUEUE_STORE } from "@/constants/normal";
import Cookies from "js-cookie";
import { createJSONStorage, persist } from "zustand/middleware";
import frontEndTraceLog from "@/actions/system/frontEndTraceLog";
import useAuthStore from "./useAuthStore";
import type { FrontEndTraceLogType } from "@/actions/entities/trace.type";

interface TraceLogQueueStore {
  traceLogQueue: FrontEndTraceLogType[];
  initLogQueue: () => Promise<void>;
  addLogToQueue: (error: Omit<FrontEndTraceLogType, "timestamp" | "clientId" | "userId">) => void;
  clearQueue: () => void;
}

const useTraceLogQueueStore = create<TraceLogQueueStore>()(
  persist(
    immer((set, get) => ({
      traceLogQueue: [],

      initLogQueue: async () => {
        const traceLogQueue = get().traceLogQueue;
        if (traceLogQueue.length <= 0) return;

        await frontEndTraceLog(traceLogQueue);
        set({ traceLogQueue: [] });
      },

      addLogToQueue: (error) => {
        set((state) => {
          const userId = useAuthStore.getState().userId;
          const clientId = Cookies.get(COOKIE_SID) || "";
          const fullLog: FrontEndTraceLogType = {
            ...error,
            clientId,
            userId,
            timestamp: Date.now(),
          };

          state.traceLogQueue.push(fullLog);
        });
      },

      clearQueue: () => {
        set((state) => {
          state.traceLogQueue = [];
        });
      },
    })),
    {
      name: TRACE_LOG_QUEUE_STORE,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        traceLogQueue: state.traceLogQueue,
      }),
    },
  ),
);

export default useTraceLogQueueStore;

export const initTraceLogQueue = () => useTraceLogQueueStore.getState().initLogQueue();
export const getTraceLogQueue = () => useTraceLogQueueStore.getState().traceLogQueue;
export const clearTraceLogQueue = () => useTraceLogQueueStore.getState().clearQueue();
